// @owners { team: patients }
export function isAltoPharmacy(pharmacyName: string): boolean {
  return /\balto pharmacy\b/i.test(pharmacyName);
}
